//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoadingCompanyInfo from '@/modules/company/components/partial-views/loading-company-info.vue';
import { mapGetters, mapActions } from 'vuex';
import vueI18n from '@/vueI18n'
import { i18n } from '@/vueI18n';
import moment from 'moment';

import { CompanyModel } from '@/modules/company/company-model';
const { fields } = CompanyModel;

export default {
  name: 'company-info',
  
  props: {
    record: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    [LoadingCompanyInfo.name]: LoadingCompanyInfo,
  },
  data() {
    return {
      model: null,
      dialog: false,
    };
  },
  computed: {
    ...mapGetters({
      // record: 'company/view/record',
      // loading: 'company/view/loading',
      toggleStatusloading: 'iam/view/statusLoading',

      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
    }),
    fields() {
      return fields;
    },
    language() {
      return vueI18n.locale
    },
  },
  methods: {
    ...mapActions({
      doToggleUserAccountStatus: 'iam/view/doToggleUserAccountStatus'
    }),
    i18n(key, args) {
      // return this.$t(key, args);
      return i18n(key, args);
    },
    presenter(fieldName) {
      const val = CompanyModel.presenter(this.record, fieldName);
      return val ? val : 'ـــ';
    },
    presenterEnum(fieldName) {
      const options = this.fields[fieldName].options;
      const val = options.filter(el => el.value == this.record[fieldName])
      return val.length ? val[0].label : 'ـــ';
    },
    presenterMap(fieldName) {
      const val = CompanyModel.presenter(this.record, fieldName);
      return val[this.currentLanguageCode] ? val[this.currentLanguageCode] : 'ـــ'; 
    },
    presenterDateTime(val) {
      // const val = CompanyModel.presenter(this.record, fieldName);
      // return val ? moment(val).locale(this.currentLanguageCode).format("dddd D MMM, YYYY h:mm A") : 'ـــ'; 
      return val ? moment(val).locale(this.currentLanguageCode).format("dddd D MMM, YYYY") + this.i18n('common.at') + moment(val).locale(this.currentLanguageCode).format("hh:mm A") : 'ـــ';
    },
    presenterDate(val) {
      // const val = CompanyModel.presenter(this.record, fieldName)
      return val ? moment(val).locale(this.currentLanguageCode).format("D MMM, YYYY") : 'ـــــــ'; 
    },
    presenterDay(fieldName) {
      return moment(CompanyModel.presenter(this.record, fieldName)).locale(this.currentLanguageCode).format("dddd");
    },
    presenterTime(fieldName) {
      // let now = moment().locale('en').format('YYYY/MM/DD');
      // let time = CompanyModel.presenter(this.record, fieldName)
      let n = this.record[fieldName]

      // console.log();
      // let date =  `${now} ${time}`;
      return moment(n,"YYYY-MM-DD'T'hh:mm:ss.SSS'Z'").locale(this.currentLanguageCode).format('hh:mm a')
    },
    presenterUser(fieldName, key) {
      const user = CompanyModel.presenter(this.record, fieldName);
      if (key == 'avatars' || key == 'avatar') {
        let avatar = null
        if (user && Array.isArray(user[key])) {
          avatar = user[key].length ? user[key][0].publicUrl : null
        } else if (user && user[key]) {
          avatar = user[key].publicUrl 
        }
        return avatar ? avatar : 'https://firebasestorage.googleapis.com/v0/b/puricom-beebe.appspot.com/o/public%2Fdefault%2Favatar.svg?alt=media&token=439fb6e6-815f-453e-9e3a-79dc0ab3d40c'
      }
      return user && user[key] ? user[key] : 'ـــ'; 
    },
    presenterClient(fieldName, key) {
      const val = CompanyModel.presenter(this.record, fieldName);
      return val && val[key] ? val[key] : 'ـــ'; 
    },
    presenterLocalization(data) {
      if (typeof data === 'object' && data !== null) {
        return data[this.currentLanguageCode] ? data[this.currentLanguageCode] : data['en']
        // if (this.currentLanguageCode in data) {
        //   return data[this.currentLanguageCode]
        // }
      }
      return  
    },
    toggleAccountStatus(id) {
      console.log(id);
      this.doToggleUserAccountStatus(id)
    },
  },

};
